import CTLDate from "application/components/CTLDate";
import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import DispatcherRowAction from "application/components/DispatcherRowAction";


const operationURLS = {
  list: "imsi/emergencyList",
  csvDownload: "eventActivityLog/downloadCSV",
};

const getColumns = (onClickToCall, onClickToVideoCall, onClearSOS) => {
  return [
    {
      Header: "Updated On",
      accessor: "emergencyCreatedOn",
      allowFilter: false,
      displayInList: true,
      allowInForm: true,
      dataType: "date",
      dateTime: true,
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Name",
      accessor: "designation",
      allowFilter: false,
      displayInList: true,
      allowInForm: true,
      dataType: "string",
      Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    },
    {
      Header: "Number",
      accessor: "extensionNumber",
      displayInList: true,
      allowFilter: true,
      allowInForm: false,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Department",
      accessor: "department",
      displayInList: true,
      allowFilter: false,
      allowInForm: false,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Zone",
      accessor: "zone",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },

    // {
    //   Header: "Department",
    //   accessor: "department",
    //   displayInList: true,
    //   allowFilter: true,
    //   dataType: "string",
    //   Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
    // },
    {
      Header: "Action",
      accessor: "uuid",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) => (
        <DispatcherRowAction
          value={value}
          row={row}
          onClickToCall={onClickToCall}
          onClickToVideoCall={onClickToVideoCall}
          onClearSOS={onClearSOS}
        />
      ),
    },
  ];
};

export { getColumns, operationURLS };
